import { Component, Inject, TemplateRef, HostListener, EventEmitter, OnInit, HostBinding } from '@angular/core';

import { ModalRef } from './modal-ref';
import { MODAL_CONTENT_DATA } from './modal.tokens';
import { AnimationEvent, trigger, state, style, transition, animate } from '@angular/animations';

const ESCAPE_KEY = 27;
const MODAL_ANIMATION_TIMINGS = '200ms cubic-bezier(0.64, 0, 0.35, 1)';

@Component({
  selector: 'suka-modal',
  template: `
    <div class="modal"
      [@slideContent]="animationState"
      (@slideContent.start)="onAnimationStart($event)"
      (@slideContent.done)="onAnimationDone($event)"
      cdkTrapFocus
    >
      <div class="modal__header">
        <h5>
          <ng-container *ngIf="!isTemplate(content.title)">{{content.title}}</ng-container>
          <ng-template *ngIf="isTemplate(content.title)" [ngTemplateOutlet]="content.title"></ng-template>
        </h5>
        <button
          *ngIf="content.closeButton"
          sukaButton="plain"
          (click)="onClose($event)"
        >
          <suka-icon icon="x"></suka-icon>
        </button>
      </div>
      <div class="modal__content">
        <ng-container *ngIf="!isTemplate(content.body)">{{content.body}}</ng-container>
        <ng-container *ngIf="isTemplate(content.body)">
          <ng-container
            *ngTemplateOutlet="content.body; context: {closeModal: closeModal.bind(this)}"
          ></ng-container>
        </ng-container>
      </div>
      <div class="modal__footer" *ngIf="showFooter">
        <suka-button-group>
          <button
            *ngFor="let secondaryAction of secondaryActions"
            sukaButton="plain"
            (click)="onAction(secondaryAction.tag)"
          >
            {{secondaryAction.label}}
          </button>
          <button
            *ngFor="let primaryAction of primaryActions"
            sukaButton="primary"
            (click)="onAction(primaryAction.tag)"
          >
            {{primaryAction.label}}
          </button>
        </suka-button-group>
      </div>
    </div>
  `,
  animations: [
    trigger('slideContent', [
      state('void', style({ transform: 'translate3d(0, 20rem, 0)', opacity: 0 })),
      state('enter', style({ transform: 'none', opacity: 1 })),
      state('leave', style({ transform: 'translate3d(0, 20rem, 0)', opacity: 0 })),
      transition('* => *', animate(MODAL_ANIMATION_TIMINGS)),
    ])
  ]
})
export class ModalContainer implements OnInit {
  public animationState: 'void' | 'enter' | 'leave' = 'enter';
  public animationStateChanged = new EventEmitter<AnimationEvent>();
  showFooter = false;
  primaryActions: [];
  secondaryActions: [];

  @HostBinding('class.modal--default') baseClass = true;

  constructor(
    public dialogRef: ModalRef,
    @Inject(MODAL_CONTENT_DATA) public content: any
  ) { }

  public ngOnInit() {
    if (this.content.actions && this.content.actions.length > 0) {
      this.showFooter = true;
      this.primaryActions = this.content.actions.filter((action) => action.type === 'primary');
      this.secondaryActions = this.content.actions.filter((action) => action.type === 'secondary');
    }
  }

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }

  public onClose(event?: any) {
    this.dialogRef.close('cancel');
  }

  public onAction(tag: string) {
    this.dialogRef.close(tag);
  }

  @HostListener('document:keydown', ['$event']) public handleKeydown(event: KeyboardEvent) {
    // tslint:disable-next-line: deprecation
    if (event.keyCode === ESCAPE_KEY) {
      this.dialogRef.close('cancel');
    }
  }

  onAnimationStart(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  onAnimationDone(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  startExitAnimation() {
    this.animationState = 'leave';
  }

  closeModal($event: any) {
    this.dialogRef.close($event);
  }
}
